/* ============================================================
   Seek Key — arrastar-para-rolar nos trilhos dos hubs (2026-08-06)
   Carregado só pelos hubs de plataforma (collection.playstation / collection.pc),
   via <script> no mesmo custom-liquid que carrega o <style> deles.

   POR QUE EXISTE
   Os trilhos são caixas de `overflow-x: auto` desenhadas para o mobile, onde o
   dedo É o mecanismo de rolagem. No desktop a curadoria veio junto mas o
   mecanismo não: a barra de rolagem está escondida (`scrollbar-width: none`),
   não há setas, e a roda do mouse rola a PÁGINA, não a fila. Medido em 06/08 no
   hub de PlayStation a 1440px: cabiam 3,3 de 13 cards e 3.659px da fila (74%)
   eram inalcançáveis com um mouse — inclusive o "+" do fim.

   Mesma receita da faixa de miniaturas da PDP (Q-034, sections/main-product.liquid):
   só mouse, limiar de 5px, e o clique é engolido se houve arrasto.

   07/08/2026 (Q-190): o desktop dos hubs virou GRADE e não rola mais na
   horizontal — o arrasto passou a ser inerte lá e ganhou uma guarda em
   pointerdown para não engolir o clique do card. O script continua carregado
   porque a fila do mobile ainda é trilho.
   ============================================================ */
(function () {
  var LIMIAR = 5; // px de movimento antes de virar "arrasto" — abaixo disso é clique

  var filas = document.querySelectorAll('.skig-rail__row, .skpc-rail__row');
  if (!filas.length) return;

  Array.prototype.forEach.call(filas, function (fila) {
    var apertado = false, xInicial = 0, rolagemInicial = 0, arrastou = false;

    function aoMover(e) {
      if (!apertado) return;
      var dx = e.clientX - xInicial;
      // enquanto não passar do limiar, deixa o clique no card acontecer normalmente
      if (!arrastou && Math.abs(dx) < LIMIAR) return;
      arrastou = true;
      // a classe desliga o scroll-snap durante o arrasto (senão a fila briga com
      // o scrollLeft que estamos escrevendo) e troca o cursor para a mão fechada
      fila.classList.add('sk-dragging');
      fila.scrollLeft = rolagemInicial - dx;
      e.preventDefault();
    }

    function aoSoltar() {
      apertado = false;
      // ao tirar a classe o snap volta e a fila assenta no card mais próximo
      fila.classList.remove('sk-dragging');
      window.removeEventListener('pointermove', aoMover);
      window.removeEventListener('pointerup', aoSoltar);
      window.removeEventListener('pointercancel', aoSoltar);
    }

    fila.addEventListener('pointerdown', function (e) {
      // toque e caneta mantêm a rolagem nativa do navegador, que já funciona bem
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      // GUARDA DA GRADE (07/08/2026, Q-190): no desktop a fila virou grade que
      // quebra em fileiras, e grade não rola na horizontal. Sem esta linha o
      // arrasto de 5px sobre uma capa engoliria o clique (o handler abaixo
      // suprime o click quando arrastou) e MATARIA a ida para o produto.
      // A checagem é aqui e não no bind porque no bind o layout pode não estar
      // resolvido: em pointerdown scrollWidth/clientWidth já são confiáveis.
      // No mobile a fila segue trilho e continua rolando (lá o arrasto é do
      // dedo, que nem passa por aqui — este handler é só mouse).
      if (fila.scrollWidth <= fila.clientWidth) return;
      apertado = true;
      arrastou = false; // sempre precede o click, então zera aqui e não no click
      xInicial = e.clientX;
      rolagemInicial = fila.scrollLeft;
      window.addEventListener('pointermove', aoMover);
      window.addEventListener('pointerup', aoSoltar);
      window.addEventListener('pointercancel', aoSoltar);
    });

    // sem isso o Chrome inicia o arrasto nativo da <img> da capa (imagem-fantasma)
    // e o gesto vira "arrastar a figura" em vez de rolar a fila
    fila.addEventListener('dragstart', function (e) { e.preventDefault(); });

    // o card inteiro é um link: se houve arrasto, engole o clique na captura
    // para não abrir a página do jogo quando a intenção era rolar
    fila.addEventListener('click', function (e) {
      if (arrastou) { e.stopPropagation(); e.preventDefault(); }
    }, true);
  });
})();
